import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background grid-noise flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-card border border-border rounded-2xl p-8 text-center animate-float-up">
        <div className="w-14 h-14 rounded-2xl bg-secondary flex items-center justify-center mx-auto mb-5"><XCircle className="w-8 h-8 text-muted-foreground" /></div>
        <h1 className="font-display text-xl font-bold mb-2" data-testid="payment-cancelled">Checkout Cancelled</h1>
        <p className="text-sm text-muted-foreground mb-6">No charge was made. You can pick a plan whenever you're ready.</p>
        <Button data-testid="payment-cancel-pricing" onClick={() => navigate("/#pricing")} className="bg-primary hover:bg-primary/90 text-primary-foreground font-semibold rounded-xl w-full">View Plans</Button>
      </div>
    </div>
  );
}
